import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import TextInput from "../../components/forms/TextInput";
import { consumePasswordResetToken, findPasswordResetToken } from "../../js/auth/passwordReset";
import { changeLocalPassword } from "../../js/auth/authOnboarding";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const match = findPasswordResetToken(token);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");

  if (!token || !match) {
    return (
      <AppLayout>
        <article className="card auth-card">
          <h1>Reset link invalid</h1>
          <p className="page-lead">Request a new password reset link.</p>
          <Link className="primary-btn" to="/forgot-password">
            Forgot password
          </Link>
        </article>
      </AppLayout>
    );
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (password.length < 8) {
      setMessage("Use at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setMessage("Passwords do not match.");
      return;
    }
    consumePasswordResetToken(token);
    changeLocalPassword(match.userId, password);
    navigate("/login", { replace: true, state: { flash: "Password updated. Sign in with your new password." } });
  }

  return (
    <AppLayout>
      <article className="card auth-card onboarding-card">
        <h1>Set a new password</h1>
        <p className="page-lead">Choose a new password for {match.email}.</p>
        <form onSubmit={handleSubmit}>
          <TextInput
            label="New password"
            name="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="new-password"
          />
          <TextInput
            label="Confirm password"
            name="confirm"
            type="password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
            autoComplete="new-password"
          />
          {message ? <p className="field-error">{message}</p> : null}
          <button type="submit" className="primary-btn btn-block">
            Update password
          </button>
        </form>
      </article>
    </AppLayout>
  );
}
